import { render, staticRenderFns } from "./AwayStatusIndicator.vue?vue&type=template&id=a4473f84&functional=true&"
import script from "./AwayStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./AwayStatusIndicator.vue?vue&type=script&lang=js&"
import style0 from "./AwayStatusIndicator.vue?vue&type=style&index=0&id=a4473f84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports